module.exports = __webpack_public_path__ + "static/img/airplane-background.a42923f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/airplane-background.jpg
// module id = 1wu/
// module chunks = 1